export default __webpack_public_path__ + "static/media/Tutorial-Step-3.2.bc3e75c4.jpg";